import React, { useRef } from "react";
import PropTypes from "prop-types";
import { CheckPicker, SelectPicker } from "rsuite";
import {
  DISTRIBUTION_FILTER_OPTIONS,
  CANCELLATION_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
} from "../constants";

const RatePlanFilters = ({
  distributionFilter,
  onDistributionChange,
  buyerFilter,
  onBuyerChange,
  buyerOptions,
  cancellationFilter,
  onCancellationChange,
  statusFilter,
  onStatusChange,
}) => {
  // Mount picker popups inside this container (instead of document.body) so
  // they stay attached to their triggers when the page scrolls.
  const filtersRef = useRef(null);
  const getPopupContainer = () => filtersRef.current;

  return (
    <div
      ref={filtersRef}
      className="rate-plans-derived-rate-page__toolbar-filters"
    >
      <CheckPicker
        data={DISTRIBUTION_FILTER_OPTIONS}
        value={distributionFilter}
        onChange={onDistributionChange}
        searchable={false}
        cleanable={false}
        placeholder="All Distribution Types"
        className="rate-plans-derived-rate-page__filter-select"
        container={getPopupContainer}
      />
      <CheckPicker
        data={buyerOptions}
        value={buyerFilter}
        onChange={onBuyerChange}
        searchable={true}
        cleanable={false}
        placeholder="All Buyers"
        className="rate-plans-derived-rate-page__filter-select"
        container={getPopupContainer}
      />
      <SelectPicker
        data={CANCELLATION_FILTER_OPTIONS}
        value={cancellationFilter}
        onChange={onCancellationChange}
        searchable={false}
        cleanable={false}
        placeholder="All Cxl Policies"
        className="rate-plans-derived-rate-page__filter-select"
        container={getPopupContainer}
      />
      <SelectPicker
        data={STATUS_FILTER_OPTIONS}
        value={statusFilter}
        onChange={onStatusChange}
        searchable={false}
        cleanable={false}
        placeholder="Active & Inactive"
        className="rate-plans-derived-rate-page__filter-select"
        container={getPopupContainer}
      />
    </div>
  );
};

RatePlanFilters.propTypes = {
  distributionFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
  onDistributionChange: PropTypes.func.isRequired,
  buyerFilter: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  onBuyerChange: PropTypes.func.isRequired,
  buyerOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
  cancellationFilter: PropTypes.string.isRequired,
  onCancellationChange: PropTypes.func.isRequired,
  statusFilter: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
};

export default RatePlanFilters;
